import { camelCase, upperFirst } from 'lodash-es';

export const idPrefix = [
  'accord',
  'btn',
  'chart',
  'check',
  'datePicker',
  'img',
  'ipt',
  'link',
  'list',
  'menu',
  'modal',
  'msg',
  'radio',
  'tab',
  'ttl',
  'txt',
];

export type IdPrefix = (typeof idPrefix)[number];

export const checkId = (prefix: IdPrefix, id?: string) => {
  return !!id?.startsWith(prefix);
};

export const makeId = (prefix: IdPrefix, name?: string, id?: string) => {
  if (!name && !id) return undefined;
  if (checkId(prefix, id)) return id;
  return `${prefix}${formatPascalCase(id) ?? formatPascalCase(name)}`;
};

export const formatPascalCase = (str?: string) => {
  if (!str) return undefined;
  return upperFirst(camelCase(str));
};

export const formatString = (str?: any) => {
  return typeof str === 'string' && str.length > 0 ? str : undefined;
};

export const getLastFromPath = (path?: string) => {
  if (!path) return undefined;
  const paths = path.split('/');
  return paths[paths.length - 1];
};
